


  
  

  var faConfetti = {
    prefix: 'fak',
    iconName: 'confetti',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'M344.4 404c-6.4-6.4-230.2-230.2-236.4-236.4c-6.5-6.5-17.1-6.5-23.6 0s-6.5 17.1 0 23.6l16.2 16.2L1 489.7c-4.7 13.2 8.1 26 21.3 21.3l282.2-99.5 16.2 16.2c6.5 6.5 17.1 6.5 23.6 0s6.5-17.1 0-23.6zM44.1 467.9l21-59.4 38.5 38.5-59.4 21zm94.4-33.3l-61.1-61.1 18.5-52.4 95 95-52.4 18.5zm87.4-30.8L108.2 286.1l18.5-52.4 151.6 151.6-52.4 18.5zM384.7 127.3c-6.5-6.5-17.1-6.5-23.6 0L256.7 231.6c-6.5 6.5-6.5 17.1 0 23.6s17.1 6.5 23.6 0l104.4-104.4c6.5-6.5 6.5-17.1 0-23.6zM367.3 280.9h-58.4c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7h58.4c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7zm-153-153c-9.2 0-16.7 7.5-16.7 16.7v58.4c0 9.2 7.5 16.7 16.7 16.7s16.7-7.5 16.7-16.7v-58.4c0-9.2-7.5-16.7-16.7-16.7zm283 134.2c-19.6-19.6-51.3-19.6-70.9 0c-19.6 19.6-19.6 51.4 0 70.9c19.6 19.6 51.3 19.6 70.9 0c19.6-19.6 19.6-51.4 0-70.9zm-23.6 47.3c-6.5 6.5-17.1 6.5-23.6 0c-6.5-6.5-6.5-17.1 0-23.6c6.5-6.5 17.1-6.5 23.6 0s6.5 17.1 0 23.6zM249.8 14.7c-19.6-19.6-51.4-19.6-70.9 0c-19.6 19.6-19.6 51.3 0 70.9c19.5 19.6 51.4 19.6 70.9 0c19.6-19.6 19.6-51.3 0-70.9zM226.2 61.9c-6.5 6.5-17.1 6.5-23.6 0c-6.5-6.5-6.5-17.1 0-23.6s17.1-6.5 23.6 0s6.5 17.1 0 23.6zM427.1 186.4a16.7 16.7 0 1 0 0 33.4 16.7 16.7 0 1 0 0-33.4zM308.9 68.2a16.7 16.7 0 1 0 0 33.4 16.7 16.7 0 1 0 0-33.4zM427.1 375.5a16.7 16.7 0 1 0 0 33.4 16.7 16.7 0 1 0 0-33.4zM119.8 68.2a16.7 16.7 0 1 0 0 33.4 16.7 16.7 0 1 0 0-33.4zm324-66.9c-9.2 0-16.7 7.5-16.7 16.7V34.8c0 9.2 7.5 16.7 16.7 16.7s16.7-7.5 16.7-16.7V18c0-9.2-7.5-16.7-16.7-16.7zm0 83.6c-9.2 0-16.7 7.5-16.7 16.7v16.7c0 9.2 7.5 16.7 16.7 16.7s16.7-7.5 16.7-16.7v-16.7c0-9.2-7.5-16.7-16.7-16.7zM410.4 51.5h-16.7c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7h16.7c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7zm83.6 0H477.2c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7H494c9.2 0 16.7-7.5 16.7-16.7S503.2 51.5 494 51.5z'
      
    ]
  };

  

  
  

  var faCrownLight = {
    prefix: 'fak',
    iconName: 'crown-light',
    icon: [
      640,
      512,
      [],
      'e003',
      
      'M536 480H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm48-320c-30.9 0-56 25.1-56 56c0 7.6 1.5 14.8 4.3 21.4L476 271.2c-5.2 3.1-10.8 4.6-16.4 4.6c-11.1 0-21.9-5.8-27.8-16.1l-74.4-130.2c11.3-10.3 18.6-25 18.6-41.5c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 16.5 7.3 31.2 18.6 41.4l-74.4 130.2c-5.9 10.4-16.7 16.1-27.8 16.1c-5.6 0-11.3-1.5-16.4-4.6l-56.3-33.8c2.7-6.6 4.3-13.8 4.3-21.4c0-30.9-25.1-56-56-56S0 185.1 0 216s25.1 56 56 56c2 0 3.9-.4 5.8-.6L128 448h384l66.2-176.6c1.9 .2 3.8 .6 5.8 .6c30.9 0 56-25.1 56-56s-25.1-56-56-56zM320 64c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM56 240c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm433.8 176H150.2l-56-149.4 53.4 32c10 6 21.3 9.1 32.9 9.1c22.9 0 44.2-12.4 55.6-32.3l75.6-132.3c2.8 .4 5.5 .8 8.4 .8s5.6-.4 8.4-.8L404 275.5c11.4 19.9 32.7 32.2 55.6 32.2c11.6 0 22.9-3.2 32.9-9.1l53.4-32L489.8 416zM584 240c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z'
      
    ]
  };

  

  
  

  var faCrownRegular = {
    prefix: 'fak',
    iconName: 'crown-regular',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M528 464H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm64-336c-26.5 0-48 21.5-48 48c0 7.1 1.6 13.7 4.4 19.8L476 239.2c-5.2 3.1-10.8 4.6-16.4 4.6c-11.1 0-21.9-5.8-27.8-16.1L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-5.9 10.4-16.7 16.1-27.8 16.1c-5.6 0-11.3-1.5-16.4-4.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8c0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5 .4 5.1 .8 7.7 .8c26.5 0 48-21.5 48-48s-21.5-48-48-48zM478.7 368H161.3l-36-96.1 14 8.4c12.4 7.5 26.7 11.4 41.1 11.4c28.7 0 55.3-15.4 69.5-40.3L320 128.7l70.1 122.7c14.2 24.9 40.8 40.3 69.5 40.3c14.5 0 28.7-3.9 41.1-11.4l14-8.4-36 96.1z'
      
    ]
  };

  

  
  

  var faCrownSolid = {
    prefix: 'fak',
    iconName: 'crown-solid',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48c0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8c0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5 .4 5.1 .8 7.7 .8c26.5 0 48-21.5 48-48s-21.5-48-48-48z'
      
    ]
  };

  



export {

  faConfetti,
  

  faCrownLight,
  

  faCrownRegular,
  

  faCrownSolid,
  

};
